import React from 'react'
import { SerialStatus, SerialWithStatus } from 'src/Libs/installations/hooks/installation-configuration/storage/use-scan-network-dialog'
import { Chip, Stack, Typography } from '@mui/material'
import { B1Battery } from '@e3dc-react/icons'
import { SxProps, Theme } from '@mui/material/styles'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

const STATUS_CHIP_SX: Partial<Record<SerialStatus, SxProps<Theme>>> = {
  new: {
    borderRadius: 2,
    bgcolor: theme => theme.palette.primary.light,
    color: theme => theme.palette.primary.dark,
    p: '4px',
  },
  missing: {
    borderRadius: 2,
    bgcolor: theme => theme.palette.error.light,
    color: theme => theme.palette.error.dark,
    p: '4px',
  },
}

interface Props {
  serialNumbers: SerialWithStatus[]
}

const ScanResultsList: React.FC<Props> = ({ serialNumbers }) => {
  const { t } = useCustomTranslation()
  const statusLabel = (status: SerialStatus): string => {
    if (status === 'new') return t('installation-configuration.storage.scan.status.new')
    if (status === 'missing') return t('installation-configuration.storage.scan.status.missing')
    return ''
  }

  return (
    <Stack gap={2}>
      {serialNumbers.map(item => (
        <Stack
          key={item.serialNumber}
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={theme => ({
            padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: theme.palette.grey.grey06,
            borderRadius: 1,
            backgroundColor: theme.palette.grey.grey07,
          })}
        >
          <Stack direction="row" alignItems="center" gap={1}>
            <B1Battery fontSize="medium" />
            <Typography variant="body2" fontWeight={600}>
              {item.serialNumber}
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" gap={1}>
            {item.status !== 'unchanged' && <Chip label={statusLabel(item.status)} size="small" sx={STATUS_CHIP_SX[item.status]} />}
          </Stack>
        </Stack>
      ))}
    </Stack>
  )
}

export default ScanResultsList
